/* eslint-disable react/no-danger */
import React from 'react';
import { useSelector } from 'react-redux';
import formatPrice from '../../helpers/formatPrice';

function Footer() {
  const quote = useSelector((state) => state.quote);
  const { createdAt, linktype, payment: { currencyInfo: { currency, code } } } = quote;

  return (
    <footer className="py-3 info-table-row">
      <span dangerouslySetInnerHTML={{ __html: quote.description }} />
      <p className="text-align-justify small m-0">
        {(linktype !== '2') && (
        <span>
          {`OBS: Os valores acima foram calculados no dia ${createdAt}`}
          {` com base no câmbio de ${formatPrice(currency, code)}. `}
        </span>
        )}
        <span>Verifique o câmbio no dia da matricula. Valores sujeitos a alteração </span>
        <span>sem prévio aviso. Nenhuma reserva foi efetuada, valores apenas cotizados </span>
        <span>sujeitos a confirmação no momento da inscrição.</span>
      </p>
      <p className="text-align-justify small m-0">
        <span>* A quitação dos programas com </span>
        <span>Austrália e Nova Zelândia como destino </span>
        <span>deverão ocorrer 90 dias antes do embarque;</span>
      </p>
      <p className="text-align-justify small m-0">
        <span>** A quitação dos programas High School </span>
        <span>deverá ocorrer conforme a política de pagamento </span>
        <span>da instituição de ensino escolhida, </span>
        <span>podendo os prazos variar de acordo com cada escola.</span>
      </p>

      {(linktype !== '2') && (
      <p className="text-align-justify small m-0">
        <span>*** Pagamento em cartão de crédito à vista ou parcelado em até 12x está sujeito</span>
        <span>a cobrança de taxa de parcelamento/processamento; Os pagamentos somente serão </span>
        <span>confirmados com a apresentação de seus comprovantes; Todas as conversões </span>
        <span>cambiais serão feitas no momento de apresentação do comprovante de pagamento.</span>
      </p>
      )}
    </footer>
  );
}

export default Footer;
